import * as React from 'react';

interface IProps {
    children: React.ReactChild | React.ReactChild[] |React.ReactElement;
}

export const CarouselItem = (props: IProps): React.ReactElement => {
    return (
        <>
            {props.children}
        </>
    );
};
